<div *ngIf="show()" class="page-loading" [@enterAnimation]>
  <div class="lds-spinner" style="z-index: 100">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>